import { Form } from "antd";
import * as React from "react";
import { ZodUnion } from "zod";
import { $ZodType } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";
import { InputNumberOrString } from "./InputNumberOrString";

type PropsAttrMetaColSpan = {
  node: $ZodType;
  path: string[];
  field?: FieldDef;
};

export const AttrMetaColSpan: React.FC<PropsAttrMetaColSpan> = (props) => {
  const { node, path, field } = props;
  const label =
    node instanceof ZodUnion
      ? makeLabel(node, path, field)
      : "Количество занимаемых ячеек в сетке";
  return (
    <Form.Item
      name={itemName(path)}
      label={label}
      rules={[{ pattern: /^(\*|\d+)?$/, message: "Требуется число или *" }]}
    >
      <InputNumberOrString allowClear title={path.join(".")} />
    </Form.Item>
  );
};
